import React from "react"; 
import "./Message.css";
import Modal from 'react-bootstrap/Modal'
import { FaCheck } from 'react-icons/fa';
import { IoCloseSharp } from 'react-icons/io5';
import { AiOutlineClose } from 'react-icons/ai';
import { FiAlertTriangle, FiAlertCircle } from 'react-icons/fi';

export default function Message (props)
{
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="message"
      >
        <div className="content">
            <div className="header">
                {
                    props?.message_type === "success" &&
                    <span className="status success"><FaCheck className="iconStatus" /> Sucesso!</span>
                }
                {
                    props?.message_type === "error" &&
                    <span className="status error"><IoCloseSharp className="iconStatus"/> Erro!</span>
                }
                {
                    props?.message_type === "warning" &&
                    <span className="status warning"><FiAlertTriangle className="iconStatus"/> Aviso!</span>
                }
                {
                    props?.message_type === "information" &&
                    <span className="status information"><FiAlertCircle className="iconStatus"/> Informação!</span>
                }
                
                <button className="close" onClick={() => props.onClose()}><AiOutlineClose className="iconButton" /></button>
            </div> 
            <div className="body">
                <p>{props.message}</p>
            </div>
        </div>
      </Modal>
    );
}
  